import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL, useAxios } from "../../../../utils/const";
import { useToast } from "../../../../Context/ToastContext";
import { useForm } from "react-hook-form";

const Logbook = () => {
  const axiosInstance = useAxios();
  const { setToastObj } = useToast();
  const { id, student_id } = useParams();
  const navigate = useNavigate();
  const { register, handleSubmit, setValue } = useForm();

  const [logbooks, setLogbooks] = useState([]);
  const [finalScore, setFinalScore] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getPenilaianLogbook();
      } catch (error) {
        setToastObj({
          msg: error,
          type: "danger",
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleSave = async (formData) => {
    setLoading(true);
    try {
      const finalScore =
        (parseFloat(formData.kelengkapan_materi) +
          parseFloat(formData.kejelasan_materi) +
          parseFloat(formData.sitasi_referensi) +
          parseFloat(formData.sasaran_pembelajaran) +
          parseFloat(formData.menghubungkan_konsep)) /
        5;
      setFinalScore(finalScore);

      const data = {
        course_group_timetable_tutorial_id: id,
        student_id: student_id,
        kelengkapan: parseFloat(formData.kelengkapan_materi),
        kejelasan: parseFloat(formData.kejelasan_materi),
        referensi: parseFloat(formData.sitasi_referensi),
        sasaran: parseFloat(formData.sasaran_pembelajaran),
        kemampuan: parseFloat(formData.menghubungkan_konsep),
        final_score: parseFloat(finalScore),
        tanggapan_logbook: formData.tanggapan_logbook,
      };

      await axiosInstance.post(
        `${API_URL}/tutorial-penilaian-logbook/nilai-logbook/`,
        data
      );
      setLoading(false);
      setToastObj({ msg: "Data Berhasil diubah", type: "success" });
      navigate(-1);
    } catch (error) {
      let errorMessage = "Terjadi kesalahan";
      if (error.response.data.msg != undefined) {
        errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
      } else {
        errorMessage = error.message;
      }
      setLoading(false);
      setToastObj({
        msg: errorMessage,
        type: "danger",
      });
    }
  };

  const getPenilaianLogbook = async () => {
    const data = {
      course_group_timetable_tutorial_id: id,
      student_id: student_id,
    };

    const response = await axiosInstance.post(
      `${API_URL}/tutorial-penilaian-logbook/find`,
      data
    );

    if (response.data.data.tutorialLogbookScore != null) {
      const tutorialLogbookScore = response.data.data.tutorialLogbookScore;
      setValue(
        "kelengkapan_materi",
        tutorialLogbookScore.kelengkapan
          ? tutorialLogbookScore.kelengkapan.toString()
          : "0"
      );
      setValue(
        "kejelasan_materi",
        tutorialLogbookScore.kejelasan
          ? tutorialLogbookScore.kejelasan.toString()
          : ""
      );
      setValue(
        "sitasi_referensi",
        tutorialLogbookScore.referensi
          ? tutorialLogbookScore.referensi.toString()
          : ""
      );
      setValue(
        "sasaran_pembelajaran",
        tutorialLogbookScore.sasaran
          ? tutorialLogbookScore.sasaran.toString()
          : ""
      );
      setValue(
        "menghubungkan_konsep",
        tutorialLogbookScore.kemampuan
          ? tutorialLogbookScore.kemampuan.toString()
          : ""
      );
      setValue(
        "tanggapan_logbook",
        tutorialLogbookScore.tanggapan ? tutorialLogbookScore.tanggapan : "-"
      );
      setFinalScore(tutorialLogbookScore.final_score);
    }

    setLogbooks(response.data.data.tutorialLogbooks);
  };

  return loading == false ? (
    <div className="container-fluid">
      <div className="card mb-4">
        <div className="card-body">
          <h1>Logbook</h1>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Dashboard</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/">Presensi Akademik</Link>
            </li>
            <li className="breadcrumb-item active">Logbook</li>
          </ol>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          {/* LOGBOOK */}
          <div className="row text-center mt-3">
            {logbooks.map((item) => (
              <>
                <div
                  className="col-md-4 d-flex"
                  style={{
                    marginLeft: "30px",
                    alignItems: "flex-start", // Membuat elemen di dalam div rata kiri
                    flexDirection: "column", // Mengatur arah vertikal (atas-bawah)
                  }}
                >
                  <i
                    className="fas fa-file-pdf text-danger"
                    style={{ fontSize: "50px" }}
                  ></i>

                  <a
                    href={`${API_URL}/public/logbooks/${item.file}`}
                    className="text-uppercase"
                    style={{
                      marginTop: "10px", // Memberi jarak antara ikon dan teks
                      fontSize: "15px",
                    }}
                    download
                  >
                    {item.file}
                  </a>
                </div>
              </>
            ))}
          </div>
          {/* RUBRIK PENILAIAN */}
          <div className="row mb-3 text-center">
            <h5>
              <strong style={{ textDecoration: "underline" }}>
                RUBRIK PENILAIAN LOGBOOK DISKUSI TUTORIAL MAHASISWA
              </strong>
            </h5>
          </div>
          <div className="row mb-3">
            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th></th>
                    <th className="text-center">Di bawah harapan</th>
                    <th className="text-center">Sesuai harapan</th>
                    <th className="text-center">Sangat baik</th>
                  </tr>
                  <tr>
                    <th></th>
                    <th className="text-center">{"< 70"}</th>
                    <th className="text-center">70-84</th>
                    <th className="text-center">{">= 85"}</th>
                  </tr>
                  <tr className="fw-bold">
                    <th colSpan="4">Hasil penelusuran mandiri (HPM)</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    {
                      name: "kelengkapan_materi",
                      label: "Kelengkapan materi sesuai tugas",
                    },
                    {
                      name: "kejelasan_materi",
                      label: "Kejelasan uraian materi",
                    },
                    { name: "sitasi_referensi", label: "Sitasi & referensi" },
                    {
                      name: "sasaran_pembelajaran",
                      label: "Kelengkapan sesuai sasaran pembelajaran",
                    },
                    {
                      name: "menghubungkan_konsep",
                      label: "Kemampuan menghubungkan konsep",
                    },
                  ].map((item, index) => (
                    <tr key={index}>
                      <td>
                        <strong>{item.label} :</strong>
                      </td>
                      <td colSpan="3">
                        <div className="form-group">
                          <input
                            className="form-control text-center"
                            type="text"
                            {...register(item.name, {
                              required: `${item.name} tidak boleh kosong!`,
                              valueAsNumber: true,
                              min: { value: 0, message: "Nilai minimum 0" },
                              max: { value: 100, message: "Nilai maximum 100" },
                            })}
                            name={item.name}
                            placeholder="Ex. 85"
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="row mb-3">
              <div className="col-md-12 mb-3">
                <div className="form-group">
                  <label
                    htmlFor="update_tanggapan_logbook"
                    className="form-label"
                  >
                    Tanggapan
                  </label>
                  <textarea
                    {...register("tanggapan_logbook")}
                    id="update_tanggapan_logbook"
                    rows="2"
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            <div className="row mb-3">
              <button
                className="btn btn-success"
                onClick={handleSubmit(handleSave)}
              >
                SIMPAN
              </button>
            </div>

            <div className="row mb-3">
              <div className="d-flex justify-content-between">
                <h5>
                  <strong className="text-decoration-underline">
                    Total Nilai : Bobot A-E, Max. 100
                  </strong>
                </h5>
                <h5>
                  <strong className="text-decoration-underline">
                    NILAI AKHIR : {finalScore}
                  </strong>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div>
      <div className="row">
        <div
          className="col-md-12 text-center align-center"
          style={{ marginTop: "20%" }}
        >
          <h1>Mohon Tunggu</h1>
        </div>
      </div>
    </div>
  );
};

export default Logbook;
